module.exports = __webpack_public_path__ + "static/media/MyBooks.72edb695.png";